import { CssBaseline, ThemeProvider } from '@mui/material'
import { useMemo } from 'react'

import { App } from '@/app/App'
import { useColorMode } from '@/hooks/useColorMode'
import { getTheme } from '@/themes/theme'

/** Applies the theme and colour mode around the app. */
export function Root(): React.JSX.Element {
  const { mode, toggleMode } = useColorMode()
  // One of the cases memoization is actually for: getTheme calls MUI createTheme,
  // which builds the whole palette/typography/overrides object, and a fresh
  // identity on every render would have ThemeProvider re-run emotion's style
  // generation for the entire tree. Keyed on mode, the only thing it depends on.
  const theme = useMemo(() => getTheme(mode), [mode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App mode={mode} onToggleMode={toggleMode} />
    </ThemeProvider>
  )
}
